<template>
    <el-menu class="navbar" mode="horizontal">
        <div class="right-menu">
            <el-dropdown class="avatar-container right-menu-item" trigger="click">
                <div class="avatar-wrapper">
                    <span class="user-name right-menu-item" v-text="account.account" v-if="account"></span>
                    <i class="el-icon-arrow-down"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <div @click="show_user_info_form_visible=true">个人信息</div>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <div @click="edit_pwd_form_visible = true">修改密码</div>
                    </el-dropdown-item>
                    <el-dropdown-item divided>
                        <div @click="handle_logout">退出登录</div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

        <el-dialog title="修改密码" width="500px" :visible.sync="edit_pwd_form_visible" @closed="handleEditPwdClosed">
            <el-form size="mini" label-width="100px" :model="edit_pwd_form" :rules="edit_pwd_rules" ref="edit_pwd_form">
                <el-form-item label="原密码" prop="originalPassword">
                    <el-input size="small" type="password" minlength="6" maxlength="15" show-password show-word-limit
                              placeholder="请输入原密码" v-model="edit_pwd_form.originalPassword"/>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input size="small" type="password" minlength="6" maxlength="15" show-password show-word-limit
                               placeholder="请输入新密码" v-model="edit_pwd_form.password"/>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="ajax_edit">确 定</el-button>
                    <el-button size="small" @click="edit_pwd_form_visible = false">取 消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="个人信息" width="500px" :visible.sync="show_user_info_form_visible">
            <el-form size="mini" label-width="80px">
                <el-form-item label="账号:">
                    <span v-if="account" v-text="account.account"></span>
                </el-form-item>
                <el-form-item label="姓名:">
                    <span v-if="account" v-text="account.name"></span>
                </el-form-item>
                <el-form-item label="手机号码:">
                    <span v-if="account" v-text="account.mobile"></span>
                </el-form-item>
            </el-form>
        </el-dialog>

    </el-menu>
</template>

<script>
    import systemApi from '@/api/system.js'
    import {mapGetters} from 'vuex'
    import Breadcrumb from '@/components/Breadcrumb'
    import Hamburger from '@/components/Hamburger'
    import Screenfull from '@/components/Screenfull'

    export default {
        components: {
            Breadcrumb,
            Hamburger,
            Screenfull
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (this.edit_pwd_form.password !== '') {
                    this.$refs.edit_pwd_form.validateField('password');
                }
                callback();
            };
            var validatePass1 = (rule, value, callback) => {
                if (value === this.edit_pwd_form.originalPassword ) {
                    callback(new Error('新密码不能与原始密码相同'));
                } else {
                    callback();
                }
            };
            return {
                show_user_info_form_visible: false,
                edit_pwd_form_visible: false, 
                edit_pwd_form: {
                    originalPassword: '',
                    password: ''
                },
                edit_pwd_rules: {
                    originalPassword: [
                        {required: true, message: '请输入原密码', trigger: 'blur'},
                        {pattern: /^(\w){6,15}$/, message: '仅支持6-15位字母、数字、下划线', trigger: 'blur'},
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {pattern: /^(\w){6,15}$/, message: '仅支持6-15位字母、数字、下划线', trigger: 'blur'},
                        {validator: validatePass1, trigger: 'blur'}
                    ]
                }

            }
        },
        computed: {
            ...mapGetters([
                'sidebar',
                'account',
            ])
        },
        methods: {
            handle_toggle_slider() {
                this.$store.dispatch('toggleSideBar');
            },
            handle_logout() {
                this.$store.dispatch('logout');
            },
            //修改密码
            ajax_edit() {
                this.$refs.edit_pwd_form.validate((valid) => {
                    if (valid) {
                        let that = this;
                        let data = that.edit_pwd_form;
                        systemApi.modifyPassword(data).then(res => {
                            if (res.data.code == "200") {
                                that.$message({message: '修改成功', type: 'success'});
                                this.handle_logout();
                            } else {
                                that.$message({message: res.data.msg, type: 'error'});
                            }
                        });
                    }
                })
            },
            handleEditPwdClosed(){
                Object.assign(this.$data.edit_pwd_form, this.$options.data().edit_pwd_form);
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

    .navbar {
        border-radius: 0px !important;
        position: relative;
        .title1 {
            font-size: 24px;
            line-height: 24px;
            color: #2A3868;
            position: absolute;
            left: 40px;
            top: 30px;
        }

        .title2 {
            font-size: 16px;
            line-height: 16px;
            color: #A7B3D1;
            position: absolute;
            left: 40px;
            top: 60px;
        }
        .hamburger-container {
            line-height: 58px;
            height: 50px;
            float: left;
            padding: 0 10px;
        }
        .breadcrumb-container {
            float: left;
        }
        .errLog-container {
            display: inline-block;
            vertical-align: top;
        }
        .right-menu {
            float: right;
            margin-right: 20px;
            height: 100%;
            .el-dropdown {
                font-size: 16px;
                color: #C1C9D9;
            }
            &:focus {
                outline: none;
            }
            .right-menu-item {
                display: inline-block;
                margin: 0 8px;
            }
            .screenfull {
                height: 20px;
                vertical-align: middle;
            }
            .international {
                vertical-align: top;
            }
            .theme-switch {
                vertical-align: 15px;
            }
            .avatar-container {
                height: 50px;
                line-height: 50px;
                /*margin-right: 30px;*/
                .avatar-wrapper {

                    cursor: pointer;
                    /*margin-top: 5px;*/
                    position: relative;
                    .user-avatar {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        vertical-align: middle;
                    }
                    .user-name {
                        vertical-align: middle;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue